module.exports = __webpack_public_path__ + "static/media/memories-Logo.4b9dc077.png";